import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/tariffDetails', request)
}

export {get}
